import { createAction, props } from '@ngrx/store';

export const LoadCategories = createAction(
  '[Categories] Load Categories'
);

export const LoadCategoriessSucces = createAction(
  '[Categories] Load Categories Success',
  props<{ data: any }>()
);

export const LoadCategoriesFailure = createAction(
  '[Categories] Load Categories Failure',
  props<{ error: any }>()
);

export const SelectCategory = createAction(
  '[Categories] Select Category Failure',
  props<{ payload: any }>()
);
